// @flow

import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { FormattedMessage } from 'react-intl';
import { Grid, type ThemeType } from '@catalytic/catalytic-ui';
import { TERMS_PRIVACY, WWW } from '../const/url';

export const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    margin: '0.5rem 0 1rem',
    textAlign: 'center'
  },
  footer: {
    ...theme.typography.extraSmallText,
    color: theme.colors.battleshipGrey
  },
  footerItems: {
    margin: '0 0.625rem'
  }
}));

export const WebformFooter = () => {
  const classes = useStyles();
  return (
    <Grid
      alignItems="flex-end"
      container
      direction="row"
      justify="center"
      wrap="nowrap"
      data-testid="webform-footer"
      className={classes.root}
    >
      <Grid item className={classes.footerItems}>
        <a
          className={classes.footer}
          data-testid="webform-footer-www"
          rel="noopener noreferrer"
          target="_blank"
          href={WWW}
        >
          <FormattedMessage
            id="webform-footer.www"
            defaultMessage="Catalytic"
          />
        </a>
      </Grid>
      <Grid item className={classes.footerItems}>
        <a
          className={classes.footer}
          data-testid="webform-footer-privacy"
          rel="noopener noreferrer"
          target="_blank"
          href={TERMS_PRIVACY}
        >
          <FormattedMessage
            id="webform-footer.privacy"
            defaultMessage="Privacy"
          />
        </a>
      </Grid>
    </Grid>
  );
};

WebformFooter.displayName = 'WebformFooter';

export default WebformFooter;
